import axios from 'axios';

const isDevelopment = false; //process.env.NODE_ENV === 'development';

export const pythonBackAxiosInstance = axios.create({
    baseURL: 'https://trends-api.loo-ai.com/api',
    withCredentials: isDevelopment,
});

export const appAxiosInstance = axios.create({
    baseURL: process.env.REACT_APP_API_URL,
    withCredentials: isDevelopment,
});

export const assistantAxiosInstance = axios.create({
    baseURL: process.env.REACT_APP_API_URL,
    withCredentials: isDevelopment,
});

export const wardrobeAxiosInstance = axios.create({
    baseURL: process.env.REACT_APP_API_URL,
    withCredentials: isDevelopment,
});

export const clothesAxiosInstance = axios.create({
    baseURL: process.env.REACT_APP_API_URL + 'v2/clothes/',
    withCredentials: isDevelopment,
});

export const recommendAxiosInstance = axios.create({
    baseURL: process.env.REACT_APP_API_URL + 'v2/recommend/',
    withCredentials: isDevelopment,
});

export const integrationsAxiosInstance = axios.create({
    baseURL: process.env.REACT_APP_API_URL + 'api/v2/integrations/',
    withCredentials: isDevelopment,
});

export const fittingAxiosInstance = axios.create({
    baseURL: process.env.REACT_APP_API_URL + 'mobile',
    withCredentials: isDevelopment,
});

pythonBackAxiosInstance.interceptors.request.use(
    config => {
        const token = localStorage.getItem('token')
        if (token) {
            config.headers['Authorization'] = `Bearer ${token}`;
        }
        return config;
    },
    error => Promise.reject(error)
);

integrationsAxiosInstance.interceptors.request.use(
    config => {
        const token = localStorage.getItem('token')
        if (token) {
            config.headers['Authorization'] = `Bearer ${token}`;
        }
        return config;
    },
    error => Promise.reject(error)
);

wardrobeAxiosInstance.interceptors.request.use(
    config => {
        const token = localStorage.getItem('token')
        if (token) {
            config.headers['Authorization'] = `Bearer ${token}`;
        }
        return config;
    },
    error => Promise.reject(error)
);

recommendAxiosInstance.interceptors.request.use(
    config => {
        const token = localStorage.getItem('token')
        if (token) {
            config.headers['Authorization'] = `Bearer ${token}`;
        }
        return config;
    },
    error => Promise.reject(error)
);

fittingAxiosInstance.interceptors.request.use(
    config => {
        const token = localStorage.getItem('token')
        if (token) {
            config.headers['Authorization'] = `Bearer ${token}`;
        }
        return config;
    },
    error => Promise.reject(error)
);

assistantAxiosInstance.interceptors.request.use(
    config => {
        const token = localStorage.getItem('token')
        if (token) {
            config.headers['Authorization'] = `Bearer ${token}`;
        }
        return config;
    },
    error => Promise.reject(error)
);

appAxiosInstance.interceptors.request.use(
    config => {
        const token = localStorage.getItem('token')
        if (token) {
            config.headers['Authorization'] = `Bearer ${token}`;
        }
        return config;
    },
    error => Promise.reject(error)
);

export const axiosDownloadFileInstance = axios.create({
    baseURL: '/storage/',
    withCredentials: isDevelopment ? true : false,
    responseType: 'blob',
})
